import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, ToastProvider } from '@nbirl/nbi-common-ui-libs';

import {
  AuthProvider,
  BulkUploadsProvider,
  DownloadProvider,
  LocationHistoryProvider,
} from './shared/context';
import { Routes } from './routes';

export const App = () => {
  const queryClient = useQueryClient();

  const handleSignOut = useCallback(() => {
    queryClient.clear();
  }, [queryClient]);

  return (
    <AuthProvider onSignOut={handleSignOut}>
      <ThemeProvider
        value={{
          table: { hightlightRowOnHover: true },
        }}
      >
        <ToastProvider>
          <Router>
            <LocationHistoryProvider>
              <BulkUploadsProvider>
                <DownloadProvider>
                  <Routes />
                </DownloadProvider>
              </BulkUploadsProvider>
            </LocationHistoryProvider>
          </Router>
        </ToastProvider>
      </ThemeProvider>
    </AuthProvider>
  );
};
